export default __webpack_public_path__ + "84f530ba78b42b5f394751807a4d3be7.png";